/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'orders': {
    width: 22,
    height: 20,
    viewBox: '0 0 22 20',
    data: '<g _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M6.737 1c0 .908-.65 1.803-1.543 1.803v13.412c.893 0 1.543.896 1.543 1.803h8.526c0-.907.65-1.803 1.543-1.803V2.803c-.893 0-1.543-.895-1.543-1.803H6.737zM3.228 2.966l-.889.109c.102.831-.367 1.722-1.15 1.818l1.509 12.288c.783-.097 1.453.654 1.555 1.486l.86-.106M18.74 2.885l.888.109c-.102.831.367 1.722 1.15 1.818L19.27 17.1c-.782-.097-1.453.654-1.555 1.486l-.86-.106" _stroke="#234357"/><path pid="1" d="M7.5 6.5h7M7.5 8.5h7M8.5 10.5h5" _stroke="#008AFF" fill-rule="nonzero"/></g>'
  }
})
